import { NgIf } from '@angular/common'
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild
} from '@angular/core'
import { fromEvent } from 'rxjs'
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators'

declare let gtag: Function

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  standalone: true,
  imports: [NgIf]
})
export class SearchInputComponent implements OnChanges {
  @Input() initialValue: string
  @Input() placeholder?: string
  @Input() analyticsEvent?: string

  @Output() termsChanged: EventEmitter<string> = new EventEmitter()

  @ViewChild('searchInput', { static: true }) searchEl: ElementRef

  ngOnChanges(): void {
    if (this.initialValue !== undefined) {
      this.searchEl.nativeElement.value = this.initialValue
    }

    fromEvent(this.searchEl.nativeElement, 'keyup')
      .pipe(
        map((event: any) => event.target.value),
        debounceTime(750),
        distinctUntilChanged()
      )
      .subscribe(async (terms: string) => {
        if (this.analyticsEvent) {
          await gtag('event', this.analyticsEvent, {
            terms
          })
        }

        this.termsChanged.emit(terms)
      })
  }

  clear() {
    this.searchEl.nativeElement.value = ''
    this.termsChanged.emit('')
  }
}
